import { NavbarLinksDesktop } from "./navbar-links-desktop";
import { NavbarLinksMobile } from "./navbar-links-mobile";

export function NavbarLinks() {
  return (
    <>
      <NavbarLinksDesktop />
      <NavbarLinksMobile />
    </>
  );
}
